// src/lib/virkedager.js
// Virkedager i Norge: mandag–fredag unntatt offentlige helligdager.
// Brukes til varselfristen i sykkelhotellet («si fra minst 3 virkedager før
// du vil hente sykkelen»), som ofte faller rundt påske og 1. mai.

// Påskedag (gregoriansk, Meeus/Jones/Butcher).
function paskedag(ar) {
  const a = ar % 19;
  const b = Math.floor(ar / 100);
  const c = ar % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const maned = Math.floor((h + l - 7 * m + 114) / 31); // 3 = mars, 4 = april
  const dag = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(Date.UTC(ar, maned - 1, dag));
}

const iso = (d) => d.toISOString().slice(0, 10);
const plussDager = (d, n) => new Date(d.getTime() + n * 24 * 60 * 60 * 1000);

const cache = new Map();
function helligdager(ar) {
  if (cache.has(ar)) return cache.get(ar);
  const p = paskedag(ar);
  const dager = new Set([
    `${ar}-01-01`, // nyttårsdag
    iso(plussDager(p, -3)), // skjærtorsdag
    iso(plussDager(p, -2)), // langfredag
    iso(p), // påskedag
    iso(plussDager(p, 1)), // 2. påskedag
    `${ar}-05-01`,
    `${ar}-05-17`,
    iso(plussDager(p, 39)), // Kristi himmelfartsdag
    iso(plussDager(p, 49)), // pinsedag
    iso(plussDager(p, 50)), // 2. pinsedag
    `${ar}-12-25`,
    `${ar}-12-26`,
  ]);
  cache.set(ar, dager);
  return dager;
}

// dato: "YYYY-MM-DD" eller Date (datoen leses i UTC, som "YYYY-MM-DD" fra skjemaer).
function erVirkedag(dato) {
  const d = typeof dato === "string" ? new Date(`${dato.slice(0, 10)}T00:00:00Z`) : dato;
  const ukedag = d.getUTCDay();
  if (ukedag === 0 || ukedag === 6) return false;
  return !helligdager(d.getUTCFullYear()).has(iso(d));
}

// Første dato som ligger `antall` hele virkedager etter `fra` (fra-dagen teller ikke).
// Eksempel: varsel mandag, 3 virkedager → torsdag.
function leggTilVirkedager(fra, antall) {
  let d = new Date(`${typeof fra === "string" ? fra.slice(0, 10) : iso(fra)}T00:00:00Z`);
  let igjen = antall;
  while (igjen > 0) {
    d = plussDager(d, 1);
    if (erVirkedag(d)) igjen -= 1;
  }
  return iso(d);
}

// Hvor mange virkedager som har gått fra `fra` til `til` (fra-dagen teller ikke, til-dagen gjør).
// Registrert mandag, i dag tirsdag → 1. Brukes til alderen på åpne ordrer (Ordrer på kontrollpanelet).
function virkedagerSiden(fra, til) {
  let d = new Date(`${typeof fra === "string" ? fra.slice(0, 10) : iso(fra)}T00:00:00Z`);
  const slutt = new Date(`${typeof til === "string" ? til.slice(0, 10) : iso(til)}T00:00:00Z`);
  let antall = 0;
  while (d < slutt) {
    d = plussDager(d, 1);
    if (erVirkedag(d)) antall += 1;
  }
  return antall;
}

// Dagens dato i Norge som "YYYY-MM-DD" (Heroku kjører i UTC).
function iDagNorge(naa = new Date()) {
  return new Intl.DateTimeFormat("sv-SE", { timeZone: "Europe/Oslo" }).format(naa);
}

module.exports = { erVirkedag, leggTilVirkedager, virkedagerSiden, iDagNorge, paskedag };
